import { useEffect, useState, useRef } from "react";

const useDeviceDetection = () => {
  const [isMobile, setIsMobile] = useState(false);
  const mobileRef = useRef(false); // Store the intermediate value in a ref

  useEffect(() => {
    const checkIfMobile = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      mobileRef.current = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|tablet|playbook|silk|kindle|nook|bb10|meego|tizen|bada|rim tablet|windows phone|palm|series60|symbian|maemo|fennec|jolla|sailfish|fxos|samsung|surface|touch/i.test(
        userAgent
      );
      setIsMobile(mobileRef.current); // Update state with the latest value
    };

    // Run detection on mount
    checkIfMobile();
  }, []); // Empty dependency ensures it only runs once on mount
  
  return isMobile;
};

export default useDeviceDetection;
